/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SeedCommonThemesResponseDto
 */
export interface SeedCommonThemesResponseDto {
    /**
     * 
     * @type {number}
     * @memberof SeedCommonThemesResponseDto
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof SeedCommonThemesResponseDto
     */
    skipped?: number;
}

/**
 * Check if a given object implements the SeedCommonThemesResponseDto interface.
 */
export function instanceOfSeedCommonThemesResponseDto(value: object): value is SeedCommonThemesResponseDto {
    return true;
}

export function SeedCommonThemesResponseDtoFromJSON(json: any): SeedCommonThemesResponseDto {
    return SeedCommonThemesResponseDtoFromJSONTyped(json, false);
}

export function SeedCommonThemesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeedCommonThemesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : json['created'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
    };
}

export function SeedCommonThemesResponseDtoToJSON(json: any): SeedCommonThemesResponseDto {
    return SeedCommonThemesResponseDtoToJSONTyped(json, false);
}

export function SeedCommonThemesResponseDtoToJSONTyped(value?: SeedCommonThemesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'],
        'skipped': value['skipped'],
    };
}

